import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GdprRequestActionViewModel } from '../../../core/models/gdpr-request-action-view-model.dto';
import { RequestService } from '../../../core/services/request.service';
import { ComponentMessengerService } from '../../../core/services/component-messenger.service';
import { HighlightEntityComponent } from './highlight-entity/highlight-entity.component';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-request-log',
    templateUrl: './request-log.component.html',
    styleUrls: ['./request-log.component.scss'],
    imports: [HighlightEntityComponent, DatePipe, TranslateModule],
})
export class RequestLogComponent implements OnInit {
    requestId: number;
    skip: number;
    take: number;
    count: number;
    requestLogs: GdprRequestActionViewModel[] = [];

    private messageSubscription;

    constructor(
        private activatedRoute: ActivatedRoute,
        private requestService: RequestService,
        private componentMessengerService: ComponentMessengerService,
    ) {}

    ngOnInit() {
        this.skip = 0;
        this.take = 50;
        this.count = 0;

        this.activatedRoute.params.subscribe((routeParams) => {
            if (this.requestId) {
                if (this.requestId === routeParams.id) {
                    this.getRequestLog(this.requestId, this.skip, this.take);
                } else {
                    this.requestLogs = [];
                    this.requestId = routeParams.id;
                    this.skip = 0;
                    this.count = 0;
                    this.getRequestLog(this.requestId, this.skip, this.take);
                }
            } else {
                this.requestLogs = [];
                this.requestId = routeParams.id;
                this.getRequestLog(this.requestId, this.skip, this.take);
            }
        });

        this.messageSubscription = this.componentMessengerService.requestMessage.subscribe((request) => {
            if (request.status) {
                this.getNewRequestLog(this.requestId, 0, 1);
            }
        });

        this.messageSubscription = this.componentMessengerService.requestPasswordMessage.subscribe(
            (isPasswordRequested) => {
                if (isPasswordRequested) {
                    this.getNewRequestLog(this.requestId, 0, 1);
                }
            },
        );
    }

    getRequestLog(id: number, skip: number, take: number): void {
        this.requestService.getRequestLog(id, skip, take).subscribe((requestLog) => {
            this.count += take;

            this.requestLogs = this.requestLogs.concat(requestLog);

            if (this.requestLogs.length >= this.count) {
                this.skip += take;
            }
        });
    }

    getNewRequestLog(id: number, skip: number, take: number): void {
        this.requestService.getRequestLog(id, skip, take).subscribe((requestLog) => {
            this.count += take;

            this.requestLogs.unshift(requestLog[0]);

            if (this.requestLogs.length >= this.count) {
                this.skip += take;
            }
        });
    }
}
